import apiService from "../../services/api";

function EventContent({ event }) {
  return (
    <div className="flex flex-col md:flex-row gap-8 mb-10">
      {event.image && (
        <div className="md:w-4/12">
          <img
            src={apiService.getImageById(event.event_public_id)}
            alt={event.title}
            className="w-full rounded shadow"
          />
        </div>
      )}

      <div className="md:w-8/12 text-justify leading-relaxed">
        {event.description || (
          <p className="text-gray-500">
            No description available.
          </p>
        )}
      </div>

    </div>
  );
}

export default EventContent;
